<template>
  <div
    class="ba-relative ba-h-0.75 ba-mt-2 ba-rounded-full ba-select-none ba-cursor-default"
    :class="[expired ? 'ba-bg-error-strong' : 'ba-bg-background-blocks']"
  >
    <div
      class="ba-absolute ba-left-0 ba-inset-y-0 ba-rounded-full ba-bg-current"
      :class="[color, width]"
    />
  </div>
</template>

<script>
export default {
  name: "vis-approval-queue-task-progressbar",
  props: {
    progress: {
      type: String,
      default: ''
    },
    expired: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: null
    }
  }
}
</script>
